import React, { useContext } from "react";
import { RicosContext } from "./../ricos-context";
import { IFRAME_COMPONENT } from "./dataHooks";
import styles from "./statics/styles/Iframe-scss";
const Iframe = ({
  iframeRef,
  isViewer,
  ...otherProps
}) => {
  const { tabIndex } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    "iframe",
    {
      ref: iframeRef,
      className: styles.iframe,
      title: "remote content",
      "data-hook": IFRAME_COMPONENT,
      style: { backgroundColor: "transparent" },
      allow: isViewer ? "fullscreen; autoplay; encrypted-media" : "fullscreen; encrypted-media",
      allowFullScreen: true,
      ...otherProps,
      tabIndex
    }
  );
};
var Iframe_default = Iframe;
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe.js.map
